enum PaymentOption {
  NewCard = 'NewCardPaymentOption',
  AfterPay = 'AfterPayPaymentOption',
  Affirm = 'AffirmPaymentOption',
  PayPal = 'PayPalPaymentOption',
  PayPalv2 = 'PayPalv2PaymentOption',
  Klarna = 'KlarnaPaymentOption',
}

export default PaymentOption
